import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function filesizeValidator( maxSize: number ): ValidatorFn {
   return ( control: AbstractControl ): ValidationErrors | null => {
      if ( control.value <= maxSize ) { return null; }

      return { filesize: { max: maxSize, actual: control.value }};
   };
}
